import { memo, useCallback, useRef } from 'react'

import { List } from 'shared/components/list'

import { PartnerFlagContent } from './components/partnerFlagContent/PartnerFlagContent'
import { PartnerFlagCover } from './components/partnerFlagCover/PartnerFlagCover'
import { SCROLL_INTO_VIEW_OPTIONS } from './configs'
import { IPartnerFlagProps } from './models'

import styles from './PartnerFlag.module.scss'

export const PartnerFlag = memo<IPartnerFlagProps>(
  ({ partnerFlag, currentExpandedFlag, isDisabled, isReadOnly, onClick, onDelete, onUpdate }) => {
    const flagRef = useRef<HTMLDivElement>(null)
    const isExpandedItem = partnerFlag.entryId === currentExpandedFlag

    const handleOnClick = useCallback(() => {
      onClick(partnerFlag.entryId)

      setTimeout(() => {
        if (flagRef && flagRef.current) {
          flagRef.current.scrollIntoView(SCROLL_INTO_VIEW_OPTIONS)
        }
      }, 100)
    }, [partnerFlag.entryId, onClick])

    return (
      <List.CollapseItem
        className={styles.flagWrapper}
        doExpand={isExpandedItem}
        onClick={handleOnClick}
        innerRef={flagRef}
      >
        <PartnerFlagCover partnerFlag={partnerFlag} />
        <PartnerFlagContent
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          partnerFlag={partnerFlag}
          onDelete={onDelete}
          onUpdate={onUpdate}
        />
      </List.CollapseItem>
    )
  }
)
